import { Button } from '../../../../core/components/atoms/Button';

interface IEssayFooter {
  onStart: () => void;
  alreadySended: boolean;
  paperURL: string;
}

export default function EssayFooter({
  onStart,
  alreadySended,
  paperURL,
}: IEssayFooter) {

  const handlePrint = () => {
    window.open(paperURL);
  };

  return (
    <div className='bg-color-lightest fixed bottom-0 left-0 flex w-full flex-row gap-xl py-4 xs:px-4 md:px-8 lg:px-[89px]'>
      <Button
        LeftIcon='open_in_new'
        size='small'
        variant='text'
        onClick={() => handlePrint()}
        iconSize='small'
        className='xs:hidden md:flex'
      >
        Imprimir folha de redação
      </Button>
      <Button
        LeftIcon='open_in_new'
        size='small'
        variant='text'
        onClick={() => handlePrint()}
        iconSize='small'
        className='xs:flex md:hidden'
      >
        Folha de redação
      </Button>
      <div className='flex-1'>
        <Button
          LeftIcon='edit'
          size='regular'
          variant='contained'
          onClick={() => onStart()}
          disabled={alreadySended}
          classNameIcon='xs:hidden lg:flex'
          full
        >
          Escrever redação
        </Button>
      </div>
    </div>
  );
}
